<template>
	<form @submit.prevent="submit" ref="form">
		<BaseFormComponent id="command_add_method" label="Method">
			<BaseSelect v-model="command.method" id="command_add_method">
				<option v-for="method in methods" :key="method">
					{{ method }}
				</option>
			</BaseSelect>
		</BaseFormComponent>

		<BaseFormComponent id="command_add_resource" label="Resource">
			<BaseInput
				type="text"
				v-model="command.resource"
				id="command_add_resource"
				maxlength="64"
				required
			/>
		</BaseFormComponent>

		<BaseFormComponent id="command_add_body" label="Body">
			<BaseJsonAceEditor
				v-model:value="command.body"
				id="command_add_body"
			/>
		</BaseFormComponent>

		<AddCommandFormFilterList
			v-model="command.filter"
			@requestAddFilter="addFilter"
			@requestRemoveFilter="removeFilter"
		/>

		<BaseFormButtons>
			<button type="submit" ref="save_button">Save</button>
		</BaseFormButtons>
	</form>
</template>

<script>
import { getErrors } from '@/core/http'
import BaseFormComponent from '@/core/components/BaseFormComponent'
import BaseInput from '@/core/components/BaseInput'
import BaseSelect from '@/core/components/BaseSelect'
import BaseJsonAceEditor from '@/core/components/BaseJsonAceEditor'
import BaseFormButtons from '@/core/components/BaseFormButtons'
import commandsHttp from '@/modules/command/commandsHttp'
import AddCommandFormFilterList from '@/modules/command/components/AddCommandFormFilterList'

export default {
	name: 'AddCommandForm',
	components: {
		BaseFormButtons,
		BaseFormComponent,
		BaseInput,
		BaseSelect,
		BaseJsonAceEditor,
		AddCommandFormFilterList,
	},
	props: {
		apiToken: {
			type: Object,
			required: true,
		},
		authenticateApiToken: {
			type: Boolean,
		},
		copyCommand: {
			type: Object,
		},
	},
	emits: [
		'commandAdded',
	],
	data() {
		return {
			methods: [
				'GET',
				'POST',
				'PUT',
				'DELETE',
			],
			command: {
				method: '',
				resource: '',
				body: '',
				filter: [],
			},
		};
	},
	watch: {
		copyCommand(newCommand) {
			if (!newCommand) {
				return;
			}

			this.resetCommandModel();

			this.command.method = newCommand.method;
			this.command.resource = newCommand.resource;

			if (newCommand.method in {
				'POST': true,
				'PUT': true,
			}) {
				this.command.body = JSON.stringify(newCommand.body, null, '\t');
			}

			this.command.filter = newCommand.filter.map(filter => ({...filter}));

			this.$refs.save_button.focus();
			this.$refs.form.scrollIntoView();
		},
	},
	methods: {
		addFilter() {
			this.command.filter.push({
				key: '',
				value: '',
			});
		},
		removeFilter(index) {
			this.command.filter.splice(index, 1);
		},
		submit() {
			const body = Object.assign({}, this.command);
			const headers = {};

			if (body.body === '') {
				body.body = undefined;
			} else {
				try {
					body.body = JSON.parse(body.body);
				} catch (e) {
					alert(e);
					return;
				}
			}

			if (body.filter === '') {
				body.filter = undefined;
			}

			body.api_token = this.apiToken;

			if (this.authenticateApiToken) {
				headers['Authorization'] = `token ${this.apiToken}`;
			}

			commandsHttp.post(body, headers)
				.then(command => {
					this.$emit('commandAdded', command);

					this.$flashMessage.show({
						type: 'success',
						text: 'The command was saved!',
					});

					this.resetCommandModel();
				})
				.catch(response => {
					const errors = getErrors(response);

					errors.forEach((text) => {
						this.$flashMessage.show({
							type: 'error',
							text,
						});
					});
				})
			;
		},
		resetCommandModel() {
			this.command.method = 'GET';
			this.command.resource = '';
			this.command.body = '';
			this.command.filter = [];
		},
	},
};
</script>
